module.exports = __webpack_public_path__ + "media/customizations/lmhh/logo-new-324e892a8f4529c92e85e329af0e4de2.png";